"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TARGET_ACTION = exports.LIBRARY_ASSET_TYPES = exports.LABEL_TYPE_OPTIONS = exports.DEFAULT_LABEL_COLOR = exports.AssetType = exports.ASSET_TAG_FILTER_PREFIX = exports.ASSET_TAG_FILTER_GROUP = void 0;
exports.assetTagColorFormat = assetTagColorFormat;
exports.assetTagKeyFormat = assetTagKeyFormat;
exports.getLabelTypeFilter = getLabelTypeFilter;
exports.getLabelTypeLink = getLabelTypeLink;
exports.getLabelTypeUsageText = getLabelTypeUsageText;
exports.getLabelTypeValue = getLabelTypeValue;
exports.getTagIdFromAssetTagFilterKey = getTagIdFromAssetTagFilterKey;
exports.invalid_short_uuid = exports.invalid_long_uuid = void 0;
exports.isAssetTagFilterKey = isAssetTagFilterKey;
exports.valid_uuid = exports.links = void 0;
var _pluralize = _interopRequireDefault(require("@kentik/ui-shared/util/pluralize"));
// unit test references
const valid_uuid = exports.valid_uuid = '9d09884f-754c-4fb9-a2bb-87c990c4832a';
const invalid_short_uuid = exports.invalid_short_uuid = '9d09884f-754c-4fb9-a2bb-87c990c4832';
const invalid_long_uuid = exports.invalid_long_uuid = '9d09884f-754c-4fb9-a2bb-87c990c4832aa';
const links = exports.links = {
  assetTags: {
    list: '/v4/settings/tags',
    add: '/v4/settings/tags/add',
    edit: id => `/v4/settings/tags/edit/${id}`,
    parents: [{
      label: 'Asset Tags',
      link: '/v4/settings/tags'
    }]
  }
};
const DEFAULT_LABEL_COLOR = exports.DEFAULT_LABEL_COLOR = '#63707D';

// ========== ui and services shared types ==========
let AssetType = exports.AssetType = /*#__PURE__*/function (AssetType) {
  AssetType["DEVICE"] = "device";
  AssetType["BOARD"] = "board";
  AssetType["CREDENTIAL_VAULT"] = "credential_vault";
  AssetType["DASHBOARD"] = "dashboard";
  AssetType["PACKAGE"] = "package";
  AssetType["POLICY"] = "policy";
  AssetType["SAVED_VIEW"] = "saved_view";
  AssetType["SYNTH_AGENT"] = "synth_agent";
  AssetType["SYNTH_TEST"] = "synth_test";
  AssetType["TENANT"] = "tenant";
  return AssetType;
}({}); // shape returned from fetching for a list of tag values
// ========== local types ==========
// ========== constants ==========

const LIBRARY_ASSET_TYPES = exports.LIBRARY_ASSET_TYPES = [AssetType.BOARD, AssetType.DASHBOARD, AssetType.SAVED_VIEW];
const LABEL_TYPE_LINKS = {
  [AssetType.BOARD]: '/v4/library',
  [AssetType.CREDENTIAL_VAULT]: '/v4/settings/credentials',
  [AssetType.DASHBOARD]: '/v4/library',
  [AssetType.DEVICE]: '/v4/infrastructure/devices',
  [AssetType.PACKAGE]: '/v4/mkp/packages',
  [AssetType.POLICY]: '/v4/alerting/policies',
  [AssetType.SAVED_VIEW]: '/v4/library',
  [AssetType.SYNTH_AGENT]: '/v4/synthetics/agents',
  [AssetType.SYNTH_TEST]: '/v4/synthetics/tests',
  [AssetType.TENANT]: '/v4/mkp/tenants'
};
const LABEL_TYPES = {
  [AssetType.BOARD]: 'Observation Deck',
  // would like to use shared/boards/boards.ts BOARD_LABEL but that'll be 'Dashboard' for ude accounts
  [AssetType.CREDENTIAL_VAULT]: 'Credential Vault',
  [AssetType.DASHBOARD]: 'Dashboard',
  [AssetType.DEVICE]: 'Device',
  [AssetType.PACKAGE]: 'Package',
  [AssetType.POLICY]: 'Policy',
  [AssetType.SAVED_VIEW]: 'Saved View',
  [AssetType.SYNTH_AGENT]: 'Agent',
  [AssetType.SYNTH_TEST]: 'Test',
  [AssetType.TENANT]: 'Tenant'
};

/**
 * Returns form options for label/asset tag types, sorted alphabetically by display name.
 * The form value is the asset type and the label is a pluralized display name.
 */
const LABEL_TYPE_OPTIONS = exports.LABEL_TYPE_OPTIONS = Object.entries(LABEL_TYPES).sort(([, a], [, b]) => a.localeCompare(b)).map(([value, label]) => ({
  value,
  label: (0, _pluralize.default)(label)
}));
const TARGET_ACTION = exports.TARGET_ACTION = {
  KEEP: {
    value: 'keep',
    label: 'Keep as is'
  },
  ALL: {
    value: 'all',
    label: 'All'
  }
};
const ASSET_TAG_FILTER_GROUP = exports.ASSET_TAG_FILTER_GROUP = 'Asset Tags';
const ASSET_TAG_FILTER_PREFIX = exports.ASSET_TAG_FILTER_PREFIX = 'asset_tag_';

// ========== utils ==========

/**
 * Returns a friendly display value for a given asset type.
 */
function getLabelTypeValue(type) {
  return LABEL_TYPES[type] || '';
}

/**
 * Returns a link to the list view for a given asset type.
 */
function getLabelTypeLink(type) {
  return LABEL_TYPE_LINKS[type];
}

/**
 * Determines whether a link routes to the library list view.
 * This is used when generating filters to send to the list view.
 * When the target list view is a library, we can further break down by asset type in the sidebar.
 */
function isLibraryLink(link) {
  return link === '/v4/library';
}

/**
 * Returns the filter type for a given asset type.
 * This is used in library list views where we can break down sidebar filters further.
 */
function getLabelFilterType(type) {
  const labelLink = getLabelTypeLink(type);
  if (isLibraryLink(labelLink)) {
    // when we're filtering by a board, we hardcode to match the board type in LibraryFilterSidebar
    // ideally we'd want to use a constant such as BOARD_LABEL from shared/boards/boards.ts, but there is a setBoardLabel override that's invoked when the account has ude enabled
    return type === AssetType.BOARD ? 'Board' : getLabelTypeValue(type);
  }
  return null;
}

/**
 * Generates a filter to send to an asset type's list view.
 */
function getLabelTypeFilter(type, id, options) {
  const items = {};
  const filterType = getLabelFilterType(type);

  // minimally allow filtering by library type no matter if it's label or not
  if (filterType) {
    items.type = [filterType];
  }
  if (options.isLabel) {
    // admin filter sidebars are currently not consistent with their label field names
    items.labelMultiSelect = [id];
    items.label = [id];
  } else {
    items.asset_tag = [id];
  }
  return items;
}

/**
 * Returns a string to indicate count and friendly display name for a given asset type with fallback to unknown casted asset types.
 */
function getLabelTypeUsageText(type, count) {
  if (!count) {
    return '';
  }
  const typeValue = getLabelTypeValue(type);
  if (!typeValue) {
    console.warn(`Unknown asset type ${type} with count ${count} found when generating label usage text`);
    return `${count} Unknown`;
  }
  return `${count} ${(0, _pluralize.default)(typeValue, count)}`;
}

/**
 * Returns true if the key matches the expected format of a valid asset tag filter
 */
function isAssetTagFilterKey(filterKey) {
  return filterKey?.startsWith(ASSET_TAG_FILTER_PREFIX);
}

/**
 * Returns the tag id parsed from a valid asset tag filter key.
 * Returns null for invalid keys.
 */
function getTagIdFromAssetTagFilterKey(filterKey) {
  if (!isAssetTagFilterKey(filterKey)) {
    return null;
  }
  return filterKey.replace(ASSET_TAG_FILTER_PREFIX, '');
}

// ========== shared validation =========

function assetTagColorFormat(val) {
  const matchesPattern = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(val);
  if (!matchesPattern) {
    throw new Error('Color must be a valid hex code');
  }
}
function assetTagKeyFormat(val) {
  const matchesPattern = /^[a-z][a-z0-9_]*$/.test(val);
  const startsWithReservedSequence = val.startsWith('kt_');
  if (!matchesPattern || startsWithReservedSequence) {
    throw new Error('Name is in an invalid format');
  }
}